"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Sampler;

var _Sampler = require("@adobe/react-spectrum-workflow/dist/Sampler");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Sampler(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Sampler.A4uSampler, null));
}